export default "__VITE_ASSET__76bd727d__"